export const getAdditionalFeesOrderItems = (fees, fixAdditionalFeeWithoutCode) => (fees == null ? void 0 : fees.map((fee, index) => {
  var _fee$price;
  return {
    id: fixAdditionalFeeWithoutCode ? fee.code ?? `additional-fee-${index}` : fee.code,
    name: fee.name ?? '',
    price: ((_fee$price = fee.price) == null ? void 0 : _fee$price.amount) ?? '0',
    quantity: 1
  };
})) || [];
//# sourceMappingURL=getAdditionalFeesOrderItems.js.map